"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const inputCollection_style_1 = __importDefault(require("./inputCollection.style"));
class InputCollection extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onClick = value => () => this.props.onClick(value);
        this.isChecked = value => {
            const { values } = this.props;
            if (Array.isArray(values)) {
                return values.indexOf(value) > -1;
            }
            return value === values;
        };
    }
    render() {
        const { title, options, classes, className, Input } = this.props;
        return (jsx_runtime_1.jsxs("div", Object.assign({ className: classnames_1.default(classes.root, className) }, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.title }, { children: title }), void 0),
                options.map(opt => {
                    const isChecked = this.isChecked(opt.value);
                    return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.option }, { children: [jsx_runtime_1.jsx(Input, { className: classnames_1.default(classes.input, {
                                    [classes.inputChecked]: isChecked
                                }), checked: isChecked, onClick: this.onClick(opt.value) }, void 0),
                            jsx_runtime_1.jsx("span", { children: opt.label }, void 0)] }), opt.value));
                })] }), void 0));
    }
}
InputCollection.propTypes = {
    title: prop_types_1.default.string.isRequired,
    options: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        value: prop_types_1.default.any.isRequired,
        label: prop_types_1.default.string.isRequired
    })).isRequired,
    classes: prop_types_1.default.object.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    Input: prop_types_1.default.func.isRequired,
    values: prop_types_1.default.oneOfType([
        prop_types_1.default.arrayOf(prop_types_1.default.string),
        prop_types_1.default.string
    ]),
    className: prop_types_1.default.string
};
InputCollection.defaultProps = {
    className: null,
    values: null
};
exports.default = react_jss_1.default(inputCollection_style_1.default)(InputCollection);
//# sourceMappingURL=index.js.map